import * as React from 'react';
const HoverContext = React.createContext({});
export default HoverContext;
